import { approvalService } from "@/service";
import { reactive } from "vue";

interface Item {
  id: string;
  name: string;
  state: string;
  state_name: string;
  create_date: string;
  user_name: string;
  desc: string;
  code: string;
  update_date: string;
}

export function fetchList() {
  const state = reactive({
    list: [] as Item[],
    loading: false,
    finished: false,
    templateList: [] as any
  });

  const onLoad = async (getstate: string, type: string, page: number, pagesize: number, params: any = {}) => {
    // 异步更新数据
    try {
      if (page === 1) {
        state.list = [];
        state.finished = false;
      }
      state.loading = true;
      const { data } = await approvalService.approvalMyRelation({
        state: getstate,
        type,
        page,
        pagesize,
        ...params
      });
      state.list.push(...data.data);
      state.loading = false;
      page++;
      if (state.list.length >= data.total) {
        state.finished = true;
      }
    } catch (error) {
      state.loading = false;
      state.finished = true;
    }
  };

  const getTemplateList = async () => {
    try {
      const { data } = await approvalService.getApprovalTempList("9", "0");
      state.templateList = [{ value: "", text: "全部" }].concat(
        data.data.map((item: any) => ({
          value: item.id,
          text: item.name
        }))
      );
    } catch (error) {}
  };

  getTemplateList();

  return {
    state,
    onLoad
  };
}
